/**
 * Fetches new token before submitting Stage form component.
 * Use case: form open in a tablet in an event expo, where visitors can submit the form themselves.
 * Form can be open without interaction for longer than token expiration time.
 *
 * Used with Stage form component, template "General form / Token refresh"
 * https://nokiantyres.stage.crasman.fi/admin/manage/scriptlets/scriptletmanager/scriptleteditor/form/template/show/IexNaBAYTe6NJF4TfJxHeg
 */

const JS_CLASS = 'js-form-refesh-token';
const elements = document.getElementsByClassName(`${ JS_CLASS }`);

if(elements.length) {
  import('./form-helper').then(({init}) => {
    for (let collection of elements) {
      init(collection, JS_CLASS);
    }
  });
}
